import merge from "lodash/merge"
import config from "@/config";

const productsName = {
    prometheus: 'prometheus',
    intuit: 'intuit',
    //shipments: 'shipments',
}
const [product, site, version] = String(process.env.VUE_APP_PRODUCT).split('.', 3)
let app = {
    $product_name: String(process.env.VUE_APP_PRODUCT_NAME),
    $package: String(process.env.VUE_APP_PACKAGE),
    $ver: {product, site, name: process.env.VUE_APP_PRODUCT_NAME},
    $product: product,
    $site: site,
    $version: version,
    $isPrometheus: product === productsName.prometheus,
    $isIntuit: product === productsName.intuit,
    //$isShipments: product === productsName.shipments,
    $isAdminSite: String(process.env.VUE_APP_PACKAGE).includes('admin'),
    $isPortalSite: String(process.env.VUE_APP_PACKAGE).includes('portal'),
    $isShipmentsSite: String(process.env.VUE_APP_PACKAGE).includes('shipments'),
    $isDevelopment: (process.env.NODE_ENV !== 'production'),
    $isTestVersion: (process.env.NODE_ENV !== 'production') || (new URL(config.api.baseURL)).hostname.startsWith('apitest.'),
}

let consts = {
    app,
    productsName,
    baseDate: '1972-01-01',
    iconsPathFolders: {
        timeline: {
            units: 'img/playBackEvents/',
            shipment: 'img/shipments/'
        }
    },
    themes: {
        'white': 'theme-white',
        'dark': 'theme-dark',
    },
    time: {
        'h24': 24*3600
    },
    siteName:{
        admin: 'admin',
        portal: 'portal'
    },
    default_route: '/',
    authGuestRoutes: ['Login', 'RequestPasswordReset', 'ResetPassword'],
    langs: [
        {id: 'en', name: 'English'},
        {id: 'es', name: 'Español'},
        {id: 'pt', name: 'Português'},
        {id: 'ar', name: 'عرب'},
    ],
    customizeColorThemes: [],
    unitsOfMeasures: {
        'distanceUnits': "km",
        'speedUnits': "kph",
        //'altitudeUnits': "m",
        'volumeUnits': "l",
        // 'fuelEconomyUnits': "lPer100km",
        'temperatureUnits': "C",
        'lightingUnits': "Lx",
        'humidityUnits': "%",
        'batteryUnits': "%",
        'shockUnits': "%",
        // 'percentageUnits': "%",
        // 'electricalUnits': "V",
    },
    timeFormats: [
        {php_format: 'HH:mm:ss',   name: 'HH:MM',   moment_js:'HH:mm'},
        {php_format: 'HH.mm.ss',   name: 'HH.MM',   moment_js:'HH.mm'},
        {php_format: 'hh:mm:ss a', name: 'HH:MM A', moment_js:'hh:mm A'},
        {php_format: 'a hh:mm:ss', name: 'A HH:MM', moment_js:'A hh:mm'},
    ],
    timeFormatsWithSeconds: {
        'HH:mm': 'HH:mm:ss',
        'HH.mm': 'HH.mm.ss',
        'hh:mm A': 'hh:mm:ss A',
        'A hh:mm': 'A hh:mm:ss',
    },
    waypointsTypes: [
        {id: 'parking', icon: 'common__parking'},
        {id: 'truck_stop', icon: 'tab-fuel'},
        {id: 'repair', icon: 'repair'},
        {id: 'dot_scales', icon: 'dot_scales'},
        {id: 'catscale', icon: 'catscale'},
        {id: 'truck_wash', icon: 'truck_wash'},
    ],
    dateFormats: [
        // altFormat - only flatpickr - https://flatpickr.js.org/options/
        {php_format: 'MM/dd/yyyy', name: 'MM/DD/YYYY', moment_js:'MM/DD/YYYY', short: 'MMM D' , altFormat: 'M/j/Y'},
        //{php_format: 'MM-dd-yyyy', name: 'MM-DD-YYYY', moment_js:'MM-DD-YYYY', short: 'MMM D', altFormat: 'M-j-Y'},
        {php_format: 'MM.dd.yyyy', name: 'MM.DD.YYYY', moment_js:'MM.DD.YYYY', short: 'MMM D', altFormat: 'M.j.Y'},
        //{php_format: 'dd-MM-yyyy', name: 'DD-MM-YYYY', moment_js:'DD-MM-YYYY', short: 'D MMM', altFormat: 'j-M-Y'},
        {php_format: 'dd/MM/yyyy', name: 'DD/MM/YYYY', moment_js:'DD/MM/YYYY', short: 'D MMM', altFormat: 'j/M/Y'},
        {php_format: 'dd.MM.yyyy', name: 'DD.MM.YYYY', moment_js:'DD.MM.YYYY', short: 'D MMM', altFormat: 'j.M.Y'},
        //{php_format: 'dd MM yyyy', name: 'DD MM YYYY', moment_js:'DD MM YYYY', short: 'D MMM', altFormat: 'M j Y'},
        {php_format: 'yyyy-MM-dd', name: 'YYYY-MM-DD', moment_js:'YYYY-MM-DD', short: 'D MMM', altFormat: 'Y-M-j'},
        {php_format: 'yyyy/MM/dd', name: 'YYYY/MM/DD', moment_js:'YYYY/MM/DD', short: 'D MMM', altFormat: 'Y/M/j'},
    ],
    geozoneDefaultPoint: {
        // id: -2,
        geozoneId: -1,
        name: '',
        radius: 10,
        color: "rgba(0,0,255,0.21)",
        type: "circle",
        points: [],//[[][]]
        // changed__time: -1,
    },
    trackSpeedColors: {
        defColors: ['#29F499', '#027AFD', '#FF8100', '#FF2D00'],
        defValues: [50, 80, 120],
    },
    colorBluetoothStatuses: {
        low: '#FF403D',
        medium: '#FF9211',
        high: '#28B25F',
        default: '#415C84',
    },
    // temperatureUnitsList:[
    //     {id: 'C', name: 'C'},
    //     {id: 'F', name: 'F'},
    //     //{id: 'K', name: 'K'},
    // ],
    xRoute: {
        availableForUnitTypes: ['car', 'tractor', 'truck'],
        track_types: [
            {id: 'straight', name: 'Straight/rigid truck (box truck, flatbed, etc.)'},
            {id: 'tractorTruck', name: 'Tractor-trailer / semi-truck (18-wheeler)'},
            {id: 'lightTruck', name: 'Light commercial truck'},
        ]
    },
    fetchAppProps: {
        dispatches: [
            {name: 'fetchUserSettings', params: {}},
            {name: 'fetchUnitsIcons', params: {}},
            {name: 'fetchUnitsHwTypesAll', params: {}},
            {name: 'fetchUnitsHwTypesSettings', params: {}},
            {name: 'fetchUnitsTypes', params: {}},
            {name: 'fetchUnitsXTypes', params: {}},

            {name: 'fetchAppUser', params: {}},
        ],
    },
    reloadAppProps: {
        dispatches: [
        ],
        commits: [
        ],
    },
    sensorsSettings: {
        default: {color: 'var(--sensors-color-default)', colorDanger: 'var(--sensors-color-danger)', icon: 'sensors'},
        temperature: {color: 'var(--sensors-color-temperature)', colorDanger: 'var(--sensors-color-danger)', icon: 'sensor__coolant_temperature'},
        coolant_temperature: {color: 'var(--sensors-color-temperature)', colorDanger: 'var(--sensors-color-danger)', icon: 'sensors__temperature'},
        humidity: {color: 'var(--sensors-color-humidity)', colorDanger: 'var(--sensors-color-danger)', icon: 'sensors__humidity'},
        lighting: {color: 'var(--sensors-color-lighting)', colorDanger: 'var(--sensors-color-danger)', icon: null},
        light: {color: 'var(--sensors-color-lighting)', colorDanger: 'var(--sensors-color-danger)', icon: null},
        battery: {color: 'var(--sensors-color-battery)', colorDanger: 'var(--sensors-color-danger)', icon: 'sensors__battery'},
        main_power: {color: 'var(--sensors-color-main_power)', colorDanger: 'var(--sensors-color-danger)', icon: null},
        shock: {color: 'var(--sensors-color-shock)', colorDanger: 'var(--sensors-color-danger)', icon: null},
        supply_air_temperature: {color: 'var(--sensors-color-supply_air_temperature)',colorDanger: 'var(--sensors-color-danger)', icon: null},
        external_temperature: {color: 'var(--sensors-color-external_temperature)',colorDanger: 'var(--sensors-color-danger)', icon: null},
        fuel_level: {color: 'var(--sensors-color-fuel_level)', colorDanger: 'var(--sensors-color-danger)', icon: 'sensors__fuel_level'},
        throttle_position: {color: 'var(--sensors-color-throttle_position)', colorDanger: 'var(--sensors-color-danger)', icon: null},

        danger: {color: 'var(--sensors-color-danger)', colorDanger: 'var(--sensors-color-danger)', icon: null},
        speed: {color: 'var(--sensors-color-speed)', colorDanger: 'var(--sensors-color-danger)', icon: 'sensors__speed'},
        miliage: {color: 'var(--sensors-color-miliage)', colorDanger: 'var(--sensors-color-danger)', icon: 'sensors__mileage'},
        mileage: {color: 'var(--sensors-color-miliage)', colorDanger: 'var(--sensors-color-danger)', icon: 'sensors__mileage'},
        rpm: {color: 'var(--sensors-color-rpm)', colorDanger: 'var(--sensors-color-danger)', icon: 'sensors__rpm'},
        idling_duration: {color: 'var(--sensors-color-idling_duration)', colorDanger: 'var(--sensors-color-danger)', icon: null},
        fuel_used: {color: 'var(--sensors-color-fuel_used)', colorDanger: 'var(--sensors-color-danger)', icon: null},
        fuel_economy: {color: 'var(--sensors-color-fuel_economy)', colorDanger: 'var(--sensors-color-danger)', icon: null},
        cumulative_fuel_economy: {color: 'var(--sensors-color-cumulative_fuel_economy)', colorDanger: 'var(--sensors-color-danger)', icon: 'sensors__cumulative_fuel_economy'},
    },
    shipmentWidgetTimeZones: [
        {id: 'America/New_York',    name: 'EST', indx: 1, offset: -5*3600},
        {id: 'America/Chicago',     name: 'CST', indx: 2, offset: -6*3600},
        {id: 'America/Denver',      name: 'MST', indx: 3, offset: -7*3600},
        {id: 'America/Los_Angeles', name: 'PST', indx: 4, offset: -8*3600},
    ],
    fetchByTimer: {
        sys_dispatches: [
            {name: 'calcDateToday', eachT: 3600, params: {}},
            {name: 'calcTokensExpire', eachT: 10, params: {}},
            {name: 'calcRequestsErrors', eachT: 5, params: {}},
            {name: 'checkSiteVersion', eachT: 100, params: {}},

            //{name: 'fetchUserSettingsChanged', eachT: 30, params: {}},
            //{name: 'fetchUnitsIconsChanged', eachT: 30, params: {}},
            {name: 'fetchUnitsHwTypesChanged', eachT: 30, params: {}},
            //{name: 'fetchUnitsTypesChanged', eachT: 30, params: {}},

            //{name: 'fetchAppUserChanged', eachT: 30, params: {}},
        ],
    },
    status: {
        // 0- 5 min - online
        // 5-15 min - online+
        //15-60 min - offline
        //   60+min - offline+
        online: 5 * 60,
        onlineRecently: 15 * 60,
        offlineRecently: 30 * 60,
        offline: 60 * 60,
    },
    donutItemNull: {name: '', value: -1, tooltipItemList: [''] , color:'#cccccc'},
    classSensors:{
        value: 'sensor-value',
        no_value: 'sensor-no-value',
    },
    statusDefaultParams: {
        keys: {
            name: 'keys',
            color: '#00D285',
        },
        orders: {
            name: 'orders',
            color: '#FF5A5A',
        },
        created: {
            name: 'created',
            color: '#00D285',
        },
        removed: {
            name: 'removed',
            color: '#FF5A5A',
        },
        active: {
            name: 'active',
            color: '#00D285',
        },
        available: {
            name: 'available',
            color: '#00D285',
        },
        used: {
            name: 'used',
            color:'#4FA8F6',
        },
        transferred: {
            name: 'transferred',
            color: '#FD7F23',
        },
        revoked: {
            name: 'revoked',
            color: '#FF403D',
        },
        parked: {
            name: 'parked',
            color: '#4FA8F6',
        },
        moving: {
            name: 'moving',
            color: '#3847D0',
        },
        mileage: {
            name: 'mileage',
            color: '#3847D0',
        },
        idling: {
            name: 'idling',
            color: '#3847D0',
        },
        offline: {
            name: 'offline',
            color: '#FF403D',
        },
        online: {
            name: 'online',
            color: '#4FA8F6'
        },
        deleted:{
            name: 'deleted',
            color: '#F76059'
        }
    },
    dataPeriod: [
        {id: 'this_day', name: 'Today', sort: 1},
        {id: 'this_week', name: 'This Week', sort: 2},
        {id: 'prev_week', name: 'Prev Week', sort: 3},
        {id: 'this_month', name: 'This Month', sort: 4},
        {id: 'prev_month', name: 'Prev Month', sort: 5},
        {id: '3_month', name: '3 Month', sort: 6},
        {id: '6_month', name: '6 Month', sort: 7},
        {id: '12_month', name: '1 Year', sort: 8},
    ],
    reportsIntervals: [
        {id: 3600, name: ("Every hour")},
        {id: 21600, name: ("Every 6 hours")},
        {id: 43200, name: ("Every 12 hours")},
        {id: 86400, name: ("Every day")},
        {id: 604800, name: ("Every week")},
        {id: 1209600, name: ("Every 2 week")},
        {id: 2678400, name: ("Every month")},
    ],
    dataTotal: [
        {id: 'total', name: 'Total'},
    ],
    divisionScale: [
        {id: 'day', name: 'Days', sort: 1},
        {id: 'week', name: 'Week', sort: 2},
        {id: 'month', name: 'Month', sort: 3},
        {id: 'year', name: 'Year', sort: 4},
    ],
    defaultSettingsLayers: {
        units: {visible: false, showInList: true, showLayer: true},
        unit_edit: {visible: false, showInList: false, showLayer: false},
        unit_mouse_move: {visible: false, showInList: false, showLayer: false},
        unit_zone: {visible: false, showInList: false, showLayer: false},
        units_groups: {visible: false, showInList: false, showLayer: false},
        geoitems: {visible: false, showInList: true, showLayer: true},
        geoitem_edit: {visible: false, showInList: false, showLayer: false},
        tracks: {visible: false, showInList: false, showLayer: false},
        greensee_tracks: {visible: false, showInList: false, showLayer: false},
        track_by_points: {visible: false, showInList: false, showLayer: false},
        track_last_minutes: {visible: false, showInList: false, showLayer: false},
        notifications: {visible: false, showInList: false, showLayer: false},
        shipments_tracks: {visible: false, showInList: false, showLayer: false},
        shipments_units: {visible: false, showInList: false, showLayer: false},
        smartSearch: {visible: false, showInList: false, showLayer: false},
        xroute: {visible: false, showInList: false, showLayer: false},
    },
    connectionTypesIcon: {
        cell: 'cell_tower',
        mcell: 'cell_tower',
        wifi: 'wi-fi',
        gps: 'gps',
    },
    api: {
        defaults: {
            timeout: 3*60 * 1000,//180 sec
            auth: {
                timeout: 3*60 * 1000,//180 sec
            },
        },

        user: {
            // fields: ['id',],
            expand: [],
        },
        users: {
            // fields: ['id',],
            expand: ['access_right'],
        },

        unit: {
            fields: ['id',],
            expand: ['access_right'],
        },
        units: {
            // fields: ['id',],
            expand: ['access_right'],
        },
        units_groups: {
            // fields: ['id',],
            expand: ['access_right'],
        },

        geopoints: {
            //fields: [],
            expand: ['access_right'],
        },
        geopoints_groups: {
            // fields: ['id',],
            expand: ['access_right'],
        },

        geozones: {
            //fields: [],
            expand: ['access_right'],
        },
        geozones_groups: {
            // fields: ['id',],
            expand: ['access_right'],
        },

        notifications: {
            //fields: [],
            expand: [],
        },

        hwtypes: {
            //fields: ['id',],
            expand: [],
        },
        weathers: {
            //fields: ['id',],
            expand: [],
        },
    },
    fieldConversion:{
        unit: {
            unit_id: 'Unit',
            name: 'Name',
            creator: 'Creator',
            hw_id: 'IMEI',
            hw_type: 'Hardware',
            reefer_type: 'Reefer type',
            type: 'Type',
            phone: 'Phone',
            icon: 'Icon',
            mark: 'Make',
            model: 'Model',
            vin: 'Vin',
            platenumber: 'Number Plate',
            photo: 'Photo',
            inputs: 'Inputs',
            outputs: 'Outputs',
            ignition: 'Ignition',
            max_speed: 'Speed Limit',
            batt_trigger: 'Battery Notification',
            speed_trigge: 'Speed Notification',
        },
        user:{
            creator: 'Creator',
            login: 'Login',
            time_zone: 'Time Zone',
            email: 'email',
            phone: 'Phone',
            legal_name: 'Company Name',
            units_of_measure: 'Measure',
            dateFormat: 'Date Format',
            timeFormat: 'Time Format',
            trackSpeedColors: 'Color Track by Speed',
            notifications: 'Notifications',
            UnitsOfMeasure: 'Measure',
            // speedUnits: '',
            // volumeUnits: '',
            // altitudeUnits: '',
            // temperatureUnits: '',
            url: 'DNS',
            favicon: 'Favicon',
            login_logo: 'Logo',
            site_name: 'Site Name',
            bg_login: 'Background',
            head__logo: 'Head Logo',
            status: 'Status',
            timeOffset: 'Time of set',
            dst: 'Daylight saving time',
            is_admin: 'Dealer',
            password: 'Password',
        },
        system: {
            user_ip: 'IP',
            user_login: 'Logged in as',
            referrer: 'DNS',
        },
        geozone:{
            name: 'Name',
            descr: 'Description',
            type: 'Type',
            creator: 'Creator',
            radius: 'Radius',
            color: 'Color',
        },
        command:{
            type: 'Type',
            cmd_reg_time: 'Registration time',
            info: 'Info',
            subtype: 'Sub type',
        },
    },
    customizeDomains: [
        {id: 'portal', label: 'Portal', disabled: false, disabled_SuperAdmin: false},
    ],
    entri: {
        add_domains: [
            {id: 'portal', label: 'Portal', def_value: 'portal'},
        ]
    },
    cameraTypesName: {
        howen: "howen",
        geotab_smarterai: "geotab_smarterai"
    },
    LiveVideo: {
        slideshow:{
            default: 1,//sec
            error: 10,//sec
        },
        timeout: 60,//sec
        unitsIdsTimeout3min: []
    },
    videoEvents: {
        durationInfoForType: [
            'time-capsule',
            'time-capsule-accident',
            'smart-search',
            'smart-search-accident',
            'accident',
        ],
    },
    components: {
        map: {
            paddingBounds: {
                paddingTopLeft: [100, 100],
                paddingBottomRight: [100, 100],
            }
        },
        SegmentControl_slider: {
            slideOptions: {
                slidesPerView: 2,
                spaceBetween:5,
                breakpoints: {
                    370: {
                        slidesPerView: 4,
                    }
                },
                // Any other options that can be got from plugin documentation
            },
        }
    },
    xroute: {
        radius: 10,
        color: {
            start: '#047AFBFF',
            end: '#28B25FFF',
        }
    },
    shipment: {
        mods: ['road','air','ocean','rail'],
        extendedShipmentByStatus: ['completed', 'cancelled'],
        route: {
            radius: 300,
            color: {
                start: '#047AFBFF',
                end: '#28B25FFF',
            }
        },
    }
}

//intuit
import consts_intuit from './intuit..js'
if (String(process.env.VUE_APP_PACKAGE).includes('intuit')) consts = merge(consts, consts_intuit)
import consts_intuit_portal from './intuit.portal.js'
if (process.env.VUE_APP_PACKAGE === 'intuit.portal') consts = merge(consts, consts_intuit_portal)
if (process.env.VUE_APP_PACKAGE === 'intuit.shipments') consts = merge(consts, consts_intuit_portal)
import consts_intuit_admin from './intuit.admin.js'
if (process.env.VUE_APP_PACKAGE === 'intuit.admin') consts = merge(consts, consts_intuit_admin)

//prometheus
import consts_prometheus from './prometheus..js'
if (String(process.env.VUE_APP_PACKAGE).includes('prometheus')) consts = merge(consts, consts_prometheus)
import consts_prometheus_portal from './prometheus.portal.js'
if (process.env.VUE_APP_PACKAGE === 'prometheus.portal') consts = merge(consts, consts_prometheus_portal)
if (process.env.VUE_APP_PACKAGE === 'prometheus.portal.geotab') consts = merge(consts, consts_prometheus_portal)
import consts_prometheus_admin from './prometheus.admin.js'
if (process.env.VUE_APP_PACKAGE === 'prometheus.admin') consts = merge(consts, consts_prometheus_admin)

export default consts
